import { Component } from '@angular/core';
import { TextComponent } from '../../shared/components/text/text.component';

@Component({
  selector: 'app-privacy',
  imports: [TextComponent],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent {}
